import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AccessibilityHiddenImg } from '@skillz/accessibility';
import { fetchStaticJson } from "../../../../shared/utils/utils";
import Collapse from "../../../../shared/components/ui/collapse/Collapse";
import plusIcon from "../../../../assests/notAuth/plusIcon.png"
import minusIcon from "../../../../assests/notAuth/minusIcon.png"
import classes from "./Faq.module.css";
import Text from "../../../../shared/components/features/text/Text";

const Faq = () => {

    const { texts } = useSelector(state => state.translate);
    const [faq, setFaq] = useState()

    const getFaq = async () => {
        let res = await fetchStaticJson(window.config.faqData)
        if (res) {
            setFaq(res.faq)
        }
    }

    useEffect(() => {
        getFaq()
    }, [])

    const IconTemplate = ({ showContent }) => {
        return <>
            <AccessibilityHiddenImg className={classes.ShowIcon} src={showContent ? minusIcon : plusIcon} />
        </>
    };

    return (
        <div className={classes.Faq}>

            <h2 className={classes.Title}>{texts.faq}</h2>

            <div className={classes.AllFAQ}>
                {faq && faq.map((section,i) =>
                    <div key={i}>
                        <Text className={classes.SectionTitle}>{section.title}</Text>
                        {section?.data?.map((faq, index) =>
                            <Collapse
                                dropClass={classes.Item}
                                key={index}
                                title={<Text>{faq.question}</Text>}
                                IconTemplate={IconTemplate}
                                listboxId={`faq-${index}`}>
                                <Text>{faq.answer}</Text>
                            </Collapse>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}
export default Faq